// extracted by mini-css-extract-plugin
export default {"header":"Header-module__header__XK9oOSt","redesignEnabled":"Header-module__redesignEnabled__cBrqzC4","previewLabel":"Header-module__previewLabel__nn9xA42"};